import { useEffect, useState } from 'react';
import useTableAssets from '@elementary/common-ui/hooks/useTableAssets';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { ENVIRONMENT_INTEGRATIONS } from '@elementary/common-ui/constants/queryKeys';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import useTestManagementTests from 'shared/hooks/useTestManagementTests';
import * as settingsApi from 'shared/services/settingsApi';

// Prefetch queries will only start when no other queries are fetching,
// and after at least one query has started
const usePrefetchQueries = () => {
  const [isReady, setIsReady] = useState(false);
  const [isError, setIsError] = useState(false);
  const isFetching = useIsFetching();
  const selectedEnvId = useSelectedEnv();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isFetching > 0) {
      setIsReady(true);
    }
  }, [isFetching]);

  const shouldPrefetch = !isFetching && isReady && !!selectedEnvId && !isError;

  useTestManagementTests({
    includeAlertDestinations: true,
    enabled: shouldPrefetch,
    onError: () => setIsError(true),
  });

  useTableAssets({ enabled: shouldPrefetch, onError: () => setIsError(true) });

  useEffect(() => {
    if (shouldPrefetch && selectedEnvId) {
      queryClient
        .fetchQuery([ENVIRONMENT_INTEGRATIONS, selectedEnvId], () =>
          settingsApi.fetchEnvironmentIntegrations(selectedEnvId),
        )
        .catch(() => setIsError(true));
    }
  }, [shouldPrefetch, selectedEnvId, queryClient]);
};

export default usePrefetchQueries;
